module.exports = __webpack_public_path__ + "static/assets/7333e5668b2faf744c41109a655e54cc.png";